import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as e } from "react/jsx-runtime";
import t from "styled-components";
import { withVDSManager as o } from "@vds-core/utilities";
import { ColorTokens as i } from "@vds-tokens/color";
import { TypographyTokens as r } from "@vds-tokens/typography";
import { Fonts as n } from "@vds-core/typography";
var l = {
    children: void 0,
    viewport: "desktop"
  },
  a = t.td.withConfig({
    displayName: "StyledCell",
    componentId: "VDS__sc-r2tlfn-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  color: ", ";\n  text-align: left;\n  vertical-align: top;\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"])), function (_ref) {
    var e = _ref.viewport;
    return "mobile" === e ? r.fontsize.body[12].value : r.fontsize.body[16].value;
  }, function (_ref2) {
    var e = _ref2.viewport;
    return "mobile" === e ? r.lineheight.body[16].value : r.lineheight.body[20].value;
  }, function (_ref3) {
    var e = _ref3.viewport;
    return "mobile" === e ? 0 : r.letterspacing.wide.value;
  }, r.fontweight.regular.value, function (_ref4) {
    var e = _ref4.viewport;
    return "mobile" === e ? n.VerizonNHGeTX : n.VerizonNHGeDS;
  }, i.elements.primary.onlight.value),
  p = function p(t) {
    return e(a, Object.assign({}, t, {
      children: t.children
    }));
  };
p.defaultProps = l;
var s = o(p);
export { s as default };